module.exports = __webpack_public_path__ + "img/4-1.1146dd25.png";